<template>
  <div class="invoices">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">Broadcast</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item">
                    <router-link :to="'/message_report/broadcast'">Broadcast</router-link>
                  </li>
                  <li class="breadcrumb-item active">Info - {{ broadcastParamSt.title }}</li>
                </ul>
              </div>
              <!-- <div class="col-auto float-right ml-auto" v-if="isRunning">
                <span class="badge badge-success" style="margin:10px;">Running</span>
                <a data-tour-step="2" class="btn add-btn" @click="logout()">
                  <i class="fa fa-stop"></i> Force Stop
                </a>
              </div> -->
            </div>
          </div>
          <!-- /Page Header -->
          <div class="row">
            <div class="col-md-12 col-sm-12 col-lg-12">

              <div class="text-right">
                <small class="text-danger">Jika jumlah Recipients tidak sesuai, silakan klik refresh</small>
                <a @click.prevent="detailBroadcast(broadcastId)" class="btn btn-light btn-sm" title="Resend">
                  <i class="fa fa-refresh"></i> Refresh
                </a>
                <div class="dropdown action-label">
                  <a class="btn btn-white btn-sm btn-rounded dropdown-toggle" href="#" data-toggle="dropdown"
                    aria-expanded="false">
                    <i class="fa fa-dot-circle-o text-danger"></i> Options
                  </a>
                  <div class="dropdown-menu dropdown-menu-right">
                    <router-link :to="'/message_report/broadcast/wizard?id=' + broadcastId" class="dropdown-item"
                      v-if="broadcastParamSt.is_send == '0' && broadcastParamSt.is_import == '0'">
                      <i class="fa fa-pencil text-success"></i> Edit
                    </router-link>
                    <router-link v-if="broadcastParamSt.is_import == '0'" :to="'/message_report/broadcast/wizard?id=' + broadcastId
                      + '&copy=1'" class=" dropdown-item">
                      <i class="fa fa-copy text-success"></i> Duplicate
                    </router-link>

                    <a @click.prevent="deleteBroadcast(broadcastId)" class="dropdown-item">
                      <i class="fa fa-trash-o text-danger"></i> Remove
                    </a>
                    <router-link :to="'/message_report/broadcast/wizard'" class="dropdown-item divider">
                      <i class="fa fa-bullhorn text-success"></i> New
                    </router-link>
                    <router-link :to="'/message_report/broadcast/wizard_import'" class="dropdown-item divider">
                      <i class="fa fa-bullhorn text-success"></i> Import
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 col-sm-12 col-lg-12"
              v-if="dataDetailBC.sending_options == 2 && dataDetailBC.sending_schedule > currentDateTimeUnix()">
              <div :class="'text text-info'">
                <i class="fa fa-clock-o"></i>
                Scheduled
                <br />
                <small>{{ formatLocalDateWithDay(dataDetailBC.sending_schedule) }}</small>
                <div class="alert alert-warning">
                  Data Broadcast untuk pesan terjadwal akan digenerate oleh sistem secara otomatis saat waktu terpenuhi.
                  Abaikan jika data di laporan Waiting belum tersedia.
                </div>
              </div>

            </div>
          </div>
          <!-- <div class="row" v-if="(dataDetailBC.sending_options !== 2 || dataDetailBC.sending_schedule < currentDateTimeUnix()) && dataDetailBC.last_sent_datetime>0 && message_anomali!=''">
            <div class="col-md-12 col-sm-12 col-lg-12">
             

              <div class="alert alert-warning" >{{ message_anomali }}

                <br />
                <br />
                <div class="text-center">
                  <button :disabled="loadingResendAnomali" @click.prevent="resendAnomaliBroadcast(broadcastId)"
                    class="btn btn-danger text-white" title="Resend">
                    <i class="fa fa-send"></i> Resend
                  </button>
                </div>
              </div>

            </div>
          </div> -->

          <template v-if="dataDetailBC.sending_options !== 2 || dataDetailBC.sending_schedule < currentDateTimeUnix()">

            <div class="row">
              <div class="col-md-6 col-sm-6 col-lg-6 col-xl-3">
                <div class="card dash-widget">
                  <div class="card-body">
                    <span class="dash-widget-icon">
                      <i class="fa fa-users"></i>
                    </span>
                    <div class="dash-widget-info">
                      <h3 ref="recipients_num">
                        <Skeleton width="100px" :count="1" />
                      </h3>
                      <span>Recipients</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-6 col-xl-3">
                <router-link
                  :to="{ path: '/message_report/broadcast_prepare', query: { broadcast_id: broadcastId, status: 'waiting' } }">
                  <div class="card dash-widget">
                    <div class="card-body">
                      <span class="dash-widget-icon text text-warning">
                        <i class="fa fa-pause"></i>
                      </span>
                      <div class="dash-widget-info">
                        <h3 ref="pending_num">
                          <Skeleton width="100px" :count="1" />
                        </h3>
                        <span>Waiting</span>
                      </div>
                    </div>
                  </div>
                </router-link>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-6 col-xl-3">
                <router-link
                  :to="{ path: '/message_report/broadcast_prepare', query: { broadcast_id: broadcastId, status: 'failed' } }">
                  <div class="card dash-widget">
                    <div class="card-body">
                      <span class="dash-widget-icon text text-danger">
                        <i class="fa fa-remove"></i>
                      </span>
                      <div class="dash-widget-info">
                        <h3 class="text text-danger" ref="error_num">
                          <Skeleton width="100px" :count="1" />
                        </h3>
                        <span>
                          Failed
                        </span>
                      </div>
                    </div>
                  </div>
                </router-link>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-6 col-xl-3">
                <router-link
                  :to="{ path: '/message_report/broadcast_prepare', query: { broadcast_id: broadcastId, status: 'executed' } }">
                  <div class="card dash-widget">
                    <div class="card-body">
                      <span class="dash-widget-icon text text-success">
                        <i class="fa fa-check"></i>
                      </span>
                      <div class="dash-widget-info">
                        <h3 class="text text-success" ref="success_num">
                          <Skeleton width="100px" :count="1" />
                        </h3>
                        <span>Success</span>
                      </div>
                    </div>
                  </div>
                </router-link>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6 col-sm-6 col-lg-6 col-xl-3">
                <div class="card dash-widget">
                  <div class="card-body">
                    <span class="dash-widget-icon text text-info">
                      <i class="fa fa-send"></i>
                    </span>
                    <div class="dash-widget-info">
                      <h3 class="text text-info" ref="delivered_num">
                        <Skeleton width="100px" :count="1" />
                      </h3>
                      <span>Delivered</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-6 col-xl-3">
                <div class="card dash-widget">
                  <div class="card-body">
                    <span class="dash-widget-icon text text-info">
                      <i class="fa fa-eye"></i>
                    </span>
                    <div class="dash-widget-info">
                      <h3 class="text text-info" ref="read_num">
                        <Skeleton width="100px" :count="1" />
                      </h3>
                      <span>Read</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-6 col-xl-3">
                <div class="card dash-widget">
                  <div class="card-body">
                    <span class="dash-widget-icon text text-info">
                      <i class="fa fa-bar-chart-o"></i>
                    </span>
                    <div class="dash-widget-info">
                      <h3 class="text text-info" ref="engagement_num">
                        <Skeleton width="100px" :count="1" />
                      </h3>
                      <span>Engagement</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>

          <!-- /Search Filter -->
          <div class="row">
            <div class="col-md-12">

              <!-- {{ broadcastParamSt }} -->
              <table class="table">
                <tbody>
                  <tr>
                    <td class="text-muted text-left" style="width:30%">Title</td>
                    <th class="text-left">{{ broadcastParamSt.title }}</th>
                  </tr>
                  <tr>
                    <td class="text-muted text-left" style="width:30%">Sending Speed</td>
                    <th class="text-left"> 
                      <a-popover placement="bottom" :key="index" :title="'Informasi Sending Speed: ' + broadcastParamSt.speed_mode">
                        <template slot="content">
                          <p style="max-width: 250px;">{{ getInfoSpeed(broadcastParamSt.speed_mode) }}</p>
                        </template>
                        <span class="badge" :class="{
                              'badge-danger': broadcastParamSt.speed_mode == 'fast',
                              'badge-info': broadcastParamSt.speed_mode == 'normal',
                              'badge-success': broadcastParamSt.speed_mode == 'safe',
                              'badge-warning': broadcastParamSt.speed_mode == 'custom'
                            }">
                              <i class="fa" v-if="broadcastParamSt.speed_mode !== 'safe'" :class="{
                                'fa-flash': broadcastParamSt.speed_mode == 'fast',
                                'fa-handshake-o': broadcastParamSt.speed_mode == 'normal',
                                'fa-wrench': broadcastParamSt.speed_mode == 'custom'
                              }"></i>
                                <svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style="width: 12px; height: 12px;">
                        <path fill-rule="evenodd" d="M12.516 2.17a.75.75 0 0 0-1.032 0 11.209 11.209 0 0 1-7.877 3.08.75.75 0 0 0-.722.515A12.74 12.74 0 0 0 2.25 9.75c0 5.942 4.064 10.933 9.563 12.348a.749.749 0 0 0 .374 0c5.499-1.415 9.563-6.406 9.563-12.348 0-1.39-.223-2.73-.635-3.985a.75.75 0 0 0-.722-.516l-.143.001c-2.996 0-5.717-1.17-7.734-3.08Zm3.094 8.016a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z" clip-rule="evenodd" />
                      </svg>
                              {{ broadcastParamSt.speed_mode }}
                            </span>
                      </a-popover>
                    
                      <!-- <span v-if="broadcastParamSt.speed_mode == 'fast'" class="badge badge-danger"><i
                          class="fa fa-flash"></i>
                        Fast
                      </span>
                      <span v-else-if="broadcastParamSt.speed_mode == 'normal'" class="badge badge-info"><i
                          class="fa fa-handshake-o"></i> Normal
                      </span>
                      <span v-else-if="broadcastParamSt.speed_mode == 'safe'" class="badge badge-success"> 
                         <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style="width: 12px; height: 12px;">
                        <path fill-rule="evenodd" d="M12.516 2.17a.75.75 0 0 0-1.032 0 11.209 11.209 0 0 1-7.877 3.08.75.75 0 0 0-.722.515A12.74 12.74 0 0 0 2.25 9.75c0 5.942 4.064 10.933 9.563 12.348a.749.749 0 0 0 .374 0c5.499-1.415 9.563-6.406 9.563-12.348 0-1.39-.223-2.73-.635-3.985a.75.75 0 0 0-.722-.516l-.143.001c-2.996 0-5.717-1.17-7.734-3.08Zm3.094 8.016a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z" clip-rule="evenodd" />
                      </svg>

                        Safe
                      </span>
                      <span v-else class="badge badge-warning"><i class="fa fa-wrench"></i> Custom
                      </span> -->


                      <div v-if="broadcastParamSt.speed_mode == 'custom'">
                        <ul>
                          <li>Delay Interval : Wait {{ broadcastParamSt.speed_wait_min }} to
                            {{ broadcastParamSt.speed_wait_max }} seconds.</li>
                          <li>Rest Mode : Stop sending after {{ broadcastParamSt.speed_stop_after }} messages and rest
                            for
                            {{ broadcastParamSt.speed_rest_for }} seconds.</li>
                        </ul>
                      </div>
                    </th>
                  </tr>

                  <tr>
                    <td class="text-muted text-left">Send From </td>
                    <th class="text-left" ref="license_id">
                      <Skeleton :count="1" />
                    </th>
                  </tr>
                  <tr v-if="broadcastParamSt.is_import == 1">
                    <td class="text-muted text-left">Destinations &amp; Messages</td>
                    <th class="text-left">
                      &nbsp;
                    </th>
                  </tr>
                  <tr v-if="broadcastParamSt.is_import == 1">
                    <td colspan="2">
                      <preview-import />
                    </td>

                  </tr>
                  <tr v-if="broadcastParamSt.is_import == 0">
                    <td class="text-muted text-left">Recipients</td>
                    <th class="text-left">
                      <!-- <template v-if="broadcastParamSt.is_group == 1">
                        <span class="badge badge-info" v-for="( row, idx ) in broadcastParamSt.to_group " :key="idx">{{
                          row.name }}</span>
                        <hr />
                      </template> -->
                      <!-- <template v-if="broadcastParamSt.is_group == 1 && broadcastParamSt.is_group_type=='group'">
                        <span class="badge badge-info" v-for="(row, idx) in broadcastParamSt.to_group" :key="idx">
                          <a href="#" data-toggle="modal" data-target="#btnShowGroup" class="text-white" @click="selectedGroup(row)">{{ row.name }}</a></span>
                      </template>
                      <template v-else-if="broadcastParamSt.is_group == 1 && broadcastParamSt.is_group_type=='tags'">
                        <span class="badge badge-info" v-for="(row, idx) in broadcastParamSt.to_group" :key="idx">
                          <a href="#" data-toggle="modal" data-target="#btnShowTags" class="text-white" @click="selectedTags(row)">{{ row.name }}</a></span>
                      </template>
                      <template v-else>
                      <div style="max-height:100px;overflow-y:scroll">
                        <span class v-for="( row, idx ) in broadcastParamSt.to " :key="idx">
                          <i v-if="row.first_name != ''">{{ row.first_name }}</i>
                          <a target="_blank" :href="'https://api.whatsapp.com/send?phone=' + row.phone_number"
                            v-if="row.is_group == 0">{{
                              row.phone_number }}</a>
                        </span>
                      </div>
                      </template> -->
                       <template
                            v-if="
                              broadcastParamSt.is_group == 1 &&
                              broadcastParamSt.is_group_type == 'group'
                            "
                          >
                            <span
                              class="badge badge-info mr-1"
                              v-for="(row, idx) in broadcastParamSt.to_group"
                              :key="idx"
                            >
                              <a
                                href="#"
                                data-toggle="modal"
                                data-target="#btnShowGroup"
                                class="text-white"
                                @click="selectedGroup(row)"
                                >{{ row.name }}</a
                              ></span
                            >
                          </template>
                          <template
                            v-else-if="
                              broadcastParamSt.is_group == 1 &&
                              broadcastParamSt.is_group_type == 'tags'
                            "
                          >
                            <span
                              class="badge badge-info mr-1"
                              v-for="(row, idx) in broadcastParamSt.to_group"
                              :key="idx"
                            >
                              <a
                                href="#"
                                data-toggle="modal"
                                data-target="#btnShowTags"
                                class="text-white"
                                @click="selectedTags(row)"
                                >{{ row.name }}</a
                              ></span
                            >
                          </template>
                          <template v-else>
                            <template v-for="(row, idx) in broadcastParamSt.to">
                              <span
                                class="badge badge-info mr-1"
                                :key="idx"
                                v-if="idx < 3"
                              >
                                {{ row.first_name }}
                                <i v-if="row.is_group == 0"
                                  >- {{ row.phone_number }}</i
                                >
                              </span>
                            </template>
                            <a-popover
                              v-if="broadcastParamSt.to.length > 3"
                              placement="bottom"
                            >
                              <template slot="content">
                                <div class="d-flex flex-column">
                                  <template
                                    v-for="(row, idx) in broadcastParamSt.to"
                                  >
                                    <small
                                      class="mb-1"
                                      :key="idx"
                                      v-if="idx > 2"
                                    >
                                      {{ row.first_name }}
                                      <i v-if="row.is_group == 0"
                                        >- {{ row.phone_number }}</i
                                      >
                                    </small>
                                  </template>
                                </div>
                              </template>
                              <template slot="title">
                                <span>More Recipients</span>
                              </template>
                              <span class="badge badge-info mr-1">
                                + {{ broadcastParamSt.to.length - 3 }} more
                              </span>
                            </a-popover>
                          </template>
                    </th>
                  </tr>
                  <tr v-if="broadcastParamSt.is_import == 0">
                    <td class="text-muted text-left">Message</td>
                    <th>
                      <div v-if="variantDataWarning" class="alert alert-warning py-2 px-3 mb-2">
                        <i class="fa fa-exclamation-triangle mr-1"></i>
                        {{ variantDataWarning }}
                      </div>
                      <div v-if="hasVariants" class="ab-detail-variants">
                        <div class="d-flex align-items-center justify-content-between flex-wrap mb-2">
                          <span class="badge ab-detail-badge">
                            <i class="fa fa-flask mr-1"></i>
                            Variasi Pesan · {{ broadcastVariants.length }} varian
                          </span>
                          <small class="text-muted">Pilih tab untuk melihat konten tiap varian.</small>
                        </div>
                        <ul class="nav nav-tabs ab-detail-tabs">
                          <li class="nav-item" v-for="(variant, idx) in broadcastVariants"
                            :key="variant.variant_code || variant.id || idx">
                            <a href="javascript:void(0)" class="nav-link"
                              :class="{ active: activeVariantIndex === idx }"
                              @click.prevent="selectVariant(idx)">
                              Content {{ variantLabel(variant, idx) }}
                            </a>
                          </li>
                        </ul>
                        <div class="ab-detail-meta" v-if="activeVariant">
                          <span class="badge badge-light">
                            Jenis pesan: {{ variantMessageTypeLabel(activeVariant) }}
                          </span>
                          <span class="badge badge-light">
                            Interactive: {{ activeVariant.interactive_message_status ? "Aktif" : "Nonaktif" }}
                          </span>
                          <span class="badge badge-light"
                            v-if="activeVariant.interactive_message_status">
                            Tombol: {{ (activeVariant.buttons && activeVariant.buttons.length) || 0 }}
                          </span>
                          <span class="badge badge-light"
                            v-if="activeVariant.footer_message_status && activeVariant.footer_message">
                            Footer: {{ activeVariant.footer_message }}
                          </span>
                        </div>
                      </div>
                      <div class="card">
                        <div class="card-body" id="preview" :style="'background: url(\'' + whatsappBackground + '\');'">
                          <preview-message :formParam="activePreviewParam" :textReplyRows="textReplyRows"
                            :buttonsRows="buttonsRows" :linkRows="linkRows" />
                        </div>
                      </div>
                    </th>
                  </tr>
                  <tr>
                    <td class="text-muted text-left">Status</td>
                    <th>
                      <template v-if="dataDetailBC.is_send == 0">
                        <span :class="'text text-warning'">
                          <i class="fa fa-pause"></i>
                          DRAFT
                        </span>
                      </template>
                      <template v-if="dataDetailBC.is_send == 1">
                        <span :class="'text text-success'" v-if="dataDetailBC.sending_options == 1">
                          <i class="fa fa-check"></i>
                          SENT
                          <br />
                          <small v-if="dataDetailBC.cron_timestamp > 0">{{
                            formatLocalDateWithDay(dataDetailBC.cron_timestamp) }}</small>
                          <small v-else>
                            {{ formatLocalDateWithDay(dataDetailBC.update_datetime) }}
                            <br />(send now)
                          </small>
                        </span>
                        <span :class="'text text-success'"
                          v-if="dataDetailBC.sending_options == 2 && dataDetailBC.sending_schedule < currentDateTimeUnix()">
                          <i class="fa fa-check"></i>
                          Sent
                          <br />
                          <small>{{ formatLocalDateWithDay(dataDetailBC.cron_timestamp) }}</small>
                        </span>
                        <span :class="'text text-info'"
                          v-if="dataDetailBC.sending_options == 2 && dataDetailBC.sending_schedule > currentDateTimeUnix()">
                          <i class="fa fa-clock-o"></i>
                          Scheduled
                          <br />
                          <small>{{ formatLocalDateWithDay(dataDetailBC.sending_schedule) }}</small>
                        </span>
                      </template>
                    </th>
                  </tr>
                  <tr v-if="dataDetailBC.is_recurring == 1">
                    <td class="text-muted text-left">Recurring</td>
                    <th>
                      <template>
                        <i class="fa fa-clock-o"></i>
                        {{ dataDetailBC.recurrence }}
                        <span>
                          <br />
                          time: {{ formatHourFromUnix(convertUTCDatetimeToUnix(dataDetailBC.recurrence_time)) }}
                        </span>
                        <span v-if="dataDetailBC.recurrence != 'daily'">
                          <br />
                          every: {{ dataDetailBC.recurrence_every }} {{ dataDetailBC.recurrence_annually_month }}
                        </span>

                        <br />end:
                        <span v-if="dataDetailBC.recurrence_end == 'never'">{{ dataDetailBC.recurrence_end }}</span>
                        <span v-else>{{ formatLocalDate(dataDetailBC.recurrence_end_date) }}</span>
                      </template>
                    </th>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <!-- /Page Content -->
      </div>
      <!-- /Page Wrapper -->
    </div>

    <!-- {{selectedContact}} -->
    <preview-group ref="modalPreviewGroup" />
    <preview-tags ref="modalPreviewTags" />
  </div>
</template>

<script>
import { Skeleton } from "vue-loading-skeleton";
import Multiselect from "vue-multiselect";
require("vue-multiselect/dist/vue-multiselect.min.css");

import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";

import Lottie from "vue-lottie";
import animationReview from "@/assets/lottie/review.json";
import animationSchedule from "@/assets/lottie/schedule.json";
import animationStore from "@/assets/lottie/viralPost.json";
import animationFilter from "@/assets/lottie/filter.json";
import animationLoadProduct from "@/assets/lottie/userConnection.json";
// import animationProcessing from "@/assets/lottie/processing.json";
// import animationData from "@/assets/animation.js";
// import animationData2 from "@/assets/animation2.js";
// import rainbow from "@/assets/lottie/rainbow.json";
// import {
//   FormWizard,
//   TabContent,
//   WizardStep,
//   WizardButton
// } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";

import Form1 from "./components/form1.vue";
import Form2 from "./components/form2.vue";
import Form3 from "./components/form3.vue";
import PreviewMessage from "./components/preview";
import PreviewImport from "./componentsImport/previewImport";
import PreviewGroup from "./componentsV2/Forms/previewGroup";
import PreviewTags from "./componentsV2/Forms/previewTags";
import {
  currentDateTimeUnix,
  formatLocalDate,
  formatLocalDateWithDay,
  convertUTCDatetimeToUnix,
  formatHourFromUnix
} from "@/utils/helper";
export default {
  components: {
    Form1,
    Form2,
    Form3,
    Lottie,
    LayoutHeader,
    LayoutSidebar,
    Skeleton,
    Multiselect,
    PreviewMessage,
    PreviewImport,
    PreviewGroup,
    PreviewTags
  },
  data() {
    return {
      textReplyRows: [],
      textReplyParams: {
        columnFilters: {
          id: "",
          title: "",
          is_publish: "publish",
        },
        page: 1,
        perPage: 500 // perPage
      },
      loadingResendAnomali: false,
      message_anomali: "",
      broadcastParamSt: {},
      broadcastVariants: [],
      activeVariantIndex: 0,
      variantDataWarning: "",
      broadcastId: "",
      isRunning: false,
      licensePhoneNumber: "",
      dataDetailBC: {
        id: "",
        destination_num: 0,
        pending_num: 0,
        error_num: 0,
        success_num: 0,
        recurrence: "",
        recurrence_annually_month: "",
        recurrence_end: "never",
        recurrence_end_date: 0,
        recurrence_every: "",
        recurrence_time: ""
      },

      whatsappBackground: process.env.VUE_APP_WHATSAPP_BACKGROUND,
      linkParams: {
        columnFilters: {
          button_title: "",
          button_text: "",
          button_response: ""
        },
        page: 1,
        perPage: 500 // perPage
      },
      buttonsParams: {
        columnFilters: {
          button_title: "",
          button_text: "",
          button_response: ""
        },
        page: 1,
        perPage: 500 // perPage
      },
      linkRows: [],
      buttonsRows: [],
      title: "Tambah Broadcast",
      copyLabel: "",
      broadcastParam: {},
      isLoading: false,
      activeIndex: 0,
      animationsForm1: { animationData: animationLoadProduct, loop: true },
      animationsForm2: { animationData: animationStore, loop: true },
      animationsForm3: { animationData: animationReview, loop: true },
      // animationsForm4: { animationData: animationSchedule, loop: true },
      // animationsForm5: { animationData: animationReview, loop: true },
      // animationsForm6: { animationData: animationProcessing, loop: true },
      // defaultOptions: { animationData: animationData, loop: false },
      // defaultOptions2: { animationData: rainbow, loop: false },
      animationSpeed: 1
    };
    //  isactive : true
  },
  computed: {
    
    infoSpeed() {
      return this.$store.state.omniwa.infoSpeed;
    },
    hasVariants() {
      return (
        Array.isArray(this.broadcastVariants) &&
        this.broadcastVariants.length > 1
      );
    },
    activeVariant() {
      if (!this.hasVariants) {
        return null;
      }
      return (
        this.broadcastVariants[this.activeVariantIndex] ||
        this.broadcastVariants[0] ||
        null
      );
    },
    activePreviewParam() {
      if (!this.hasVariants || !this.activeVariant) {
        return this.broadcastParamSt;
      }
      const variant = this.activeVariant;
      const message =
        variant.message && typeof variant.message === "object"
          ? variant.message
          : {};
      return Object.assign({}, this.broadcastParamSt, {
        message: {
          text: typeof message.text === "string" ? message.text : "",
          message_type: message.message_type || "text",
          file_url: typeof message.file_url === "string" ? message.file_url : ""
        },
        is_custom_url: !!variant.is_custom_url,
        interactive_message_status: !!variant.interactive_message_status,
        interactive_message_type: variant.interactive_message_type || "",
        buttons: Array.isArray(variant.buttons) ? variant.buttons : [],
        footer_message_status: !!variant.footer_message_status,
        footer_message:
          typeof variant.footer_message === "string"
            ? variant.footer_message
            : "",
        list_button_text: variant.list_button_text || "Options"
      });
    },
    // broadcastParamSt() {
    //   return this.$store.state.omniwa.broadcastParamSt;
    // }
    // isShowForm() {
    //   return this.$store.state.monitoring.isShowForm;
    // }
  },
  // watch: {
  //   broadcastParamSt: {
  //     handler: async function(val, oldVal) {
  //       if (val != oldVal) {
  //         this.broadcastParam = val;
  //       }
  //     },
  //     deep: true
  //   }
  // },
  async created() {
    let id = this.$route.query.id;
    this.$store.dispatch('omniwa/detailBroadcastSpeedInfo')
    if (typeof id != "undefined" && id != "") {
      this.title = "Ubah Broadcast";
      this.broadcastId = id;
      // console.log("id", id);
      this.detailBroadcast(id);
      this.checkAnomaliBroadcast(id)
    }
    this.loadTextReply();
    // this.loadReplyButtons();
    // this.loadReplyLink();
  },
  methods: {
    setupVariants(data) {
      this.broadcastVariants = [];
      this.activeVariantIndex = 0;
      this.variantDataWarning = "";

      if (!data || typeof data !== "object") {
        return;
      }
      if (typeof data.variants === "undefined" || data.variants === null) {
        return;
      }
      if (!Array.isArray(data.variants)) {
        this.variantDataWarning =
          "Data varian Variasi Pesan tidak dapat dibaca karena format respons tidak sesuai. Konten utama tetap ditampilkan.";
        console.warn(
          "[Broadcast Detail] Format variants tidak sesuai:",
          data.variants
        );
        return;
      }

      const variants = data.variants.filter(function (variant) {
        return variant && typeof variant === "object";
      });

      variants.sort(function (a, b) {
        const orderA = Number(a.variant_order);
        const orderB = Number(b.variant_order);
        const hasOrderA = !isNaN(orderA) && isFinite(orderA);
        const hasOrderB = !isNaN(orderB) && isFinite(orderB);
        if (hasOrderA && hasOrderB && orderA !== orderB) {
          return orderA - orderB;
        }
        if (hasOrderA && !hasOrderB) return -1;
        if (!hasOrderA && hasOrderB) return 1;
        return String(a.variant_code || "").localeCompare(
          String(b.variant_code || "")
        );
      });

      this.broadcastVariants = variants;

      const hasInvalidItems = variants.length !== data.variants.length;
      const hasIncomplete = variants.some(function (variant) {
        return !variant.message || typeof variant.message !== "object";
      });

      if (hasInvalidItems) {
        this.variantDataWarning =
          "Sebagian data varian tidak dapat dibaca. Varian yang valid tetap ditampilkan.";
      } else if (hasIncomplete) {
        this.variantDataWarning =
          "Sebagian data varian tidak lengkap. Varian yang datanya tersedia tetap dapat dilihat.";
      }
    },
    selectVariant(index) {
      if (index < 0 || index >= this.broadcastVariants.length) {
        return;
      }
      this.activeVariantIndex = index;
    },
    variantLabel(variant, index) {
      if (variant && variant.variant_code) {
        return variant.variant_code;
      }
      return String.fromCharCode(65 + index);
    },
    variantMessageTypeLabel(variant) {
      const type =
        variant && variant.message ? variant.message.message_type : "";
      const labels = {
        text: "Teks",
        image: "Gambar",
        video: "Video",
        document: "Dokumen"
      };
      return labels[type] || type || "-";
    },
    getInfoSpeed(data) {
      if (this.infoSpeed !== null) {
        if(data == 'custom'){
          return 'Pesan akan terkirim berdasarkan interval dan delay yang diatur.'
        }
        return this.infoSpeed[data];
      }
      return "";
    },
    selectedTags(row){
      this.$refs.modalPreviewTags.getGroupSelected(row);
    },
    selectedGroup(row){
      this.$refs.modalPreviewGroup.getGroupSelected(row);
    },
    async loadTextReply() {
      this.buttonsLoading = await true;
      this.textReplyParams.page = 0;
      await this.$store
        .dispatch("automation/listTextReply", this.textReplyParams) // sesuai kan dengan method di API
        .then(response => {
          const { data } = response;
          this.textReplyRows = data.data;
          this.buttonsLoading = false;
        })
        .catch(error => {
          this.buttonsLoading = false;
          console.log(error);
        });
    },
    currentDateTimeUnix() {
      return currentDateTimeUnix();
    },
    deleteBroadcast(id) {
      this.$fire({
        title: "Are you sure you will continue this action?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      }).then(async r => {
        if (typeof r.value != "undefined" && r.value == true) {
          let dataParam = {};
          dataParam = {
            broadcast_id: id
          };
          this.$store
            .dispatch("omniwa/deleteBroadcast", dataParam) // sesuai kan dengan method di API
            .then(response => {
              // this.searchData();

              this.$fire({
                title: "Success",
                text: response["msg"],
                type: "success",
                timer: 2000
              }).then(r => {
                this.$router.push({
                  path: `/message_report/broadcast`
                });
              });
            });
        }
      });
    },
    async logout() {
      let phone = this.licensePhoneNumber;
      await this.$fire({
        title: "Do you want to logout this whatsapp session?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      }).then(async r => {
        if (typeof r.value != "undefined" && r.value == true) {
          await this.$store
            .dispatch("omniwa/logout", phone)
            .then(response => {
              this.$fire({
                title: "Success",
                text: response["msg"],
                type: "success",
                timer: 2000
              });
            })
            .catch(error => { });
        }
      });
    },
    formatLocalDate(value) {
      return formatLocalDate(value);
    },
    convertUTCDatetimeToUnix(utcDatetime) {
      return convertUTCDatetimeToUnix(utcDatetime);
    },
    formatHourFromUnix(utcdttz) {
      return formatHourFromUnix(utcdttz);
    },
    formatLocalDateWithDay(value) {
      return formatLocalDateWithDay(value);
    },
    async getLabel(licenseId) {
      await this.$store
        .dispatch("license/getLicenseById", licenseId)
        .then(response => {
          var { data } = response;
          this.licenseInfo = data;
          this.licensePhoneNumber = data.license_phone_number;
          this.$refs.license_id.innerHTML = data.license_name;
          this.$refs.license_id.innerHTML +=
            '<br /><span class="text-muted"><i class="fa fa-phone"></i> ' +
            data.license_phone_number +
            "</span>";
          this.$store
            .dispatch("omniwa/isOnline", data.license_phone_number)
            .then(responseDet => {
              var { data } = responseDet;

              if (data.status === 1) {
                this.$refs.license_id.innerHTML +=
                  ' <i title="Online" class="text-success fa fa-signal"></i>';
              } else {
                this.$refs.license_id.innerHTML +=
                  ' <i title="Offline" class="text-danger fa fa-signal"></i>';
              }
            });
        });
    },
    async resendAnomaliBroadcast(id) {
      this.isLoading = true;
      this.loadingResendAnomali = true;
      let dataParam = await {};
      dataParam = await {
        broadcast_id: id
      };
      this.$fire({
        title: "Are you sure you will continue this action?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      }).then(async r => {
        if (typeof r.value != "undefined" && r.value == true) {
          await this.$store
            .dispatch("omniwa/resendAnomaliBroadcast", dataParam) // sesuai kan dengan method di API
            .then(response => {
              // var { data } = response;
              console.log(response)
              if (response['data']['status'] == 0) {
                this.message_anomali = response['msg']
              }
              this.loadingResendAnomali = false;
            }).
            catch(() => {
              this.loadingResendAnomali = false;
            });
          await this.checkAnomaliBroadcast(id)

        } else {
          this.loadingResendAnomali = false;
        }
      });
    },
    async checkAnomaliBroadcast(id) {
      this.isLoading = true;
      let dataParam = await {};
      dataParam = await {
        broadcast_id: id
      };
      // let formData = await {};
      await this.$store
        .dispatch("omniwa/checkAnomaliBroadcast", dataParam) // sesuai kan dengan method di API
        .then(response => {
          // var { data } = response;
          console.log(response)
          if (response['data']['status'] == 0) {
            this.message_anomali = response['msg']
          } else {
            this.message_anomali = ''
          }
        });

    },
    async detailBroadcast(id) {
      this.isLoading = true;

      //set false dulu
      // this.$store.dispatch("omniroom/setIsShowBroadcast", false);

      let dataParam = await {};
      dataParam = await {
        broadcast_id: id
      };
      let formData = await {};
      await this.$store
        .dispatch("omniwa/detailBroadcast", dataParam) // sesuai kan dengan method di API
        .then(response => {
          var { data } = response;
          this.dataDetailBC = data;
          this.setupVariants(data);
          formData = JSON.parse(data.raw);
          formData.is_import = data.is_import
          // formData = JSON.parse(data);
          this.isLoading = false;
          this.getLabel(data.license_id);
          this.$refs.recipients_num.innerHTML = data.destination_num;
          this.$refs.pending_num.innerHTML = data.pending_num;
          this.$refs.error_num.innerHTML = data.error_num;
          this.$refs.success_num.innerHTML = data.success_num;
          this.$refs.delivered_num.innerHTML = data.total_deliver;
          this.$refs.read_num.innerHTML = data.total_read;
          this.$refs.engagement_num.innerHTML = "0%";
          if (data.total_read > 0) {
            let totalEngagement = (data.total_read / data.success_num) * 100;
            if (totalEngagement > 100) {
              totalEngagement = 100;
            }
            this.$refs.engagement_num.innerHTML =
              Math.round(totalEngagement.toFixed(2)) + "%";
          }
          let totalRunning =
            data.pending_num + data.error_num + data.success_num;
          if (totalRunning > 1 && totalRunning < data.destination_num) {
            this.isRunning = true;
          }
        });
      formData.buttons = await [];
      await this.$store
        .dispatch("omniwa/detailButtonsBroadcast", dataParam) // sesuai kan dengan method di API
        .then(response => {
          var { data } = response;
          if (data != null && data.length) {
            data.forEach((value, idx) => {
              // formData.buttons.push(value.id);
              formData.buttons.push(value);
            });
          }
        });

      this.broadcastParamSt = formData;
      console.log("formData", formData);
      formData.broadcast_id = id;

      await this.$store.dispatch("omniwa/actBroadcastParamSt", formData);
      // this.showBroadcast();
      // var elem = this.$refs.formBcEdit;
      // elem.click();
    },

    async loadReplyLink() {
      this.buttonsLoading = await true;
      this.linkParams.page = 0;
      await this.$store
        .dispatch("automation/listReplyLink", this.linkParams) // sesuai kan dengan method di API
        .then(response => {
          const { data } = response;
          this.linkRows = data.data;
          this.buttonsLoading = false;
        })
        .catch(error => {
          this.buttonsLoading = false;
          console.log(error);
        });
    },
    async loadReplyButtons() {
      this.buttonsLoading = await true;
      this.buttonsParams.page = 0;
      await this.$store
        .dispatch("automation/listReplyButtons", this.buttonsParams) // sesuai kan dengan method di API
        .then(response => {
          const { data } = response;
          this.buttonsRows = data.data;
          this.buttonsLoading = false;
        })
        .catch(error => {
          this.buttonsLoading = false;
          console.log(error);
        });
    },
    messageFilter(message) {
      return message.replace(/\r?\n/g, "<br />");
    },
    remove_tags(html) {
      var html = html.replace("<br />", "||br||");
      var tmp = document.createElement("DIV");
      tmp.innerHTML = html;
      html = tmp.textContent || tmp.innerText;
      return html.replace("||br||", "<br />");
    }
  },
  beforeDestroy() {
    let formData = {
      //from state
      is_custom_url: false,
      rowDetail: {},
      is_duplicate: false,
      broadcast_id: "",
      title: "",
      provider: "whatsapp",
      license_id: "",
      to_group: [],
      to: [],
      is_group: 1, //for group set 1, for personal set 0
      is_group_type: "group", //group/tags
      message: {
        text: "",
        message_type: "text", //text,image,document
        file_url: ""
      },
      sending_options: 1,
      sending_schedule: "",
      is_recurring: 0,
      recurring_form: {
        recurrence: "",
        recurrence_time: "00:01",
        recurrence_every: "",
        recurrence_annually_month: "",
        recurrence_end: "never",
        recurrence_end_date: ""
      },
      is_send: 1,
      to_test: "",
      footer_message_status: false,
      footer_message: "",
      buttons: [{id:""}, {id:""}, {id:""}, {id:""}, {id:""}, {id:""}, {id:""}, {id:""}, {id:""}, {id:""}]
    };
    this.$store.dispatch("omniwa/actBroadcastParamSt", formData);
  },
  mounted() {
    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }

    // Select 2
    if ($(".select").length > 0) {
      $(".select").select2({
        minimumResultsForSearch: -1,
        width: "100%"
      });
    }
    // Multiselect
    if ($("#customleave_select").length > 0) {
      $("#customleave_select").multiselect();
    }
    if ($("#edit_customleave_select").length > 0) {
      $("#edit_customleave_select").multiselect();
    }

    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function (e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "form-send"
};
</script>

<style scoped>
.ab-detail-variants {
  margin-bottom: 12px;
}

.ab-detail-badge {
  background: #fff1e5;
  color: #d97a18;
  border: 1px solid #f6d7b8;
  font-weight: 600;
  padding: 5px 10px;
  border-radius: 999px;
}

.ab-detail-tabs {
  flex-wrap: wrap;
  border-bottom: 1px solid #f1f3f5;
}

.ab-detail-tabs .nav-link {
  color: #555;
  border: 1px solid transparent;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  padding: 8px 14px;
}

.ab-detail-tabs .nav-link:hover {
  color: #d97a18;
}

.ab-detail-tabs .nav-link.active {
  color: #d97a18;
  background: #fff;
  border-color: #fe9b44 #fe9b44 #fff;
  font-weight: 600;
}

.ab-detail-meta {
  display: flex;
  flex-wrap: wrap;
  margin: 10px 0 6px;
}

.ab-detail-meta .badge {
  margin-right: 6px;
  margin-bottom: 6px;
  font-weight: 500;
  font-size: 12px;
}

@media (max-width: 575.98px) {
  .ab-detail-tabs .nav-link {
    padding: 6px 10px;
    font-size: 13px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/broadcast/info.vue